var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.shouldShowIndicator)?_c('div',{directives:[{name:"tippy",rawName:"v-tippy"}],class:_vm.styles,attrs:{"title":_vm.tooltipText}},[_c('img',{staticClass:"w-5 h-5",attrs:{"src":_vm.asset('images/account/rsvpify-premium.svg')}}),_vm._v(" "),(_vm.block)?_c('span',{staticClass:"uppercase text-xs ml-1"},[_vm._v("Premium Feature")]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }